import classNames from 'classnames';
import React      from 'react';

const TradeStoreSliderIconPrev = function(props) {
  const {
          disabled,
          onClick,
        } = props;

  return (
    <svg
      onClick={onClick}
      className={classNames('swiper_button_prev', { disabled })}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 9L13.5 16.7942V1.20577L0 9Z" fill="#D9D9D9" />
    </svg>
  );
};

export default TradeStoreSliderIconPrev;